import { render, staticRenderFns } from "./NodeEditText.vue?vue&type=template&id=1d16b746&lang=pug&"
import script from "./NodeEditText.vue?vue&type=script&lang=js&"
export * from "./NodeEditText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports